import generatePicker from "antd/es/date-picker/generatePicker";
import "antd/lib/date-picker/style/index";
import dateFnsGenerateConfig from "rc-picker/lib/generate/dateFns";

const DatePicker = generatePicker(dateFnsGenerateConfig);

export default DatePicker;
